import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { POSTERS } from "./constants/poster-constants";
import PosterDetailPage from "./pages/PosterDetailPage/PosterDetailPage";
import Overview from "./pages/Overview/Overview";
import Datenschutz from "./pages/Datenschutz/Datenschutz";
import Impressum from "./pages/Impressum/Impressum";
import ScrollToTop from "./components/layouts/ScrollToTop/ScrollToTop";

const App: React.FC = () => {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Overview />} />
                {POSTERS.map((p) => (
                    <Route
                        key={p.route}
                        path={p.route}
                        element={<PosterDetailPage poster={p} />}
                    />
                ))}
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
            </Routes>
        </Router>
    );
};

export default App;
